import React from 'react';
import { StyledTableCell, StyledTableCellName, StyledTableRow } from 'components/styles_components/table';

const ShowItemTableRow = ({ label, children }) => {
  return (
    <StyledTableRow>
      <StyledTableCellName>{label}</StyledTableCellName>
      <StyledTableCell align='right'>{children || '-'}</StyledTableCell>
    </StyledTableRow>
  )
};

export default ShowItemTableRow;
